import { withKeys } from "@/common/helpers/list-keys";
import { groupFilters } from "../_helpers/group-filters";
import { FilterList, FilterListProps } from "./filter-list";

export function GroupedFilterList({ filters, currentFilterValues, onFilterChange }: FilterListProps) {
  const groups = groupFilters(filters);

  return withKeys(groups, (group, index) => `${group.label ?? "group"}-${index}`).map(({ key, item: group }) => (
    <div key={key} className="space-y-4">
      {group.label && (
        <div className="text-muted-foreground text-xs font-medium tracking-wide uppercase">{group.label}</div>
      )}
      <FilterList filters={group.filters} currentFilterValues={currentFilterValues} onFilterChange={onFilterChange} />
    </div>
  ));
}
